module.exports = __webpack_public_path__ + "static/media/disco.2dfd7148.jpg";